export default __webpack_public_path__ + "assets/icon-toggle-on.eaa24fd3.webp";